import { createSvgIcon } from '@mui/material';

const SubmissionModeIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M16.2081 20.5832H14.0415C10.9773 20.5832 9.44528 20.5832 8.49338 19.6312C7.54147 18.6793 7.54147 17.1473 7.54147 14.0832V8.6665C7.54147 5.60237 7.54147 4.07031 8.49338 3.11841C9.44528 2.1665 10.9773 2.1665 14.0415 2.1665H15.4966C16.3822 2.1665 16.825 2.1665 17.2232 2.33143C17.6213 2.49636 17.9344 2.80947 18.5607 3.4357L21.4389 6.31397C22.0652 6.94019 22.3782 7.25332 22.5432 7.65149C22.7081 8.04965 22.7081 8.49247 22.7081 9.37809V14.0832C22.7081 17.1473 22.7081 18.6793 21.7562 19.6312C20.8044 20.5832 19.2722 20.5832 16.2081 20.5832Z"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.7498 2.7085V3.79183C16.7498 5.83458 16.7498 6.85596 17.3844 7.49056C18.019 8.12516 19.0404 8.12516 21.0831 8.12516H22.1665"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.54103 5.4165C5.74611 5.4165 4.29103 6.87158 4.29103 8.6665V17.3332C4.29103 20.3974 4.29103 21.9294 5.24293 22.8812C6.19484 23.8332 7.7269 23.8332 10.791 23.8332H16.2081C18.003 23.8332 19.4581 22.378 19.4581 20.5832"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3333 11.9165H15.6667M11.3333 16.2498H18.9167"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'SubmissionModeIcon',
  );
  return (
    <IconCmp
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      style={{
        fill: 'none',
      }}
      {...props}
    />
  );
};
export default SubmissionModeIcon;
